import { ModelConfig } from '@scale/shared-types';
import { ModelConfigSchema } from '@scale/shared/pipelinev3/contentUnderstanding/paramsSchema';
import React from 'react';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Button } from '@scale/scaleui';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface ModelConfigsBuilderProps {
  name: string;
  existingValue?: Array<ModelConfig>;
  updateProperty: (arg: Array<ModelConfig> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const ModelConfigsBuilder: React.FC<ModelConfigsBuilderProps> = ({
  name,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const configs = existingValue;

  const addConfig = () => {
    const newConfigs = [...configs];
    newConfigs.push({
      endpointName: 'Endpoint Name',
    });
    updateProperty(newConfigs);
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-lg">{name}</div>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={configs}
        setElements={updateProperty}
        getKey={config => `${config.endpointName}`}
        getTitle={config => `${config.endpointName}`}
        getSchema={_ => ModelConfigSchema}
      />
      <Button onClick={() => addConfig()}>Add Model Config</Button>
    </div>
  );
};

export default ModelConfigsBuilder;
